const BaseModel = require('../BaseModel');
const EntitySelectable = require('./EntitySelectable');

class EntityMultiSelect extends EntitySelectable {
  static dataType = 'entity-multi-select';

  get isMultiSelect() { return(true) }
}

BaseModel.models[EntityMultiSelect.dataType] = EntityMultiSelect;
module.exports = EntityMultiSelect;
